import momenttz from 'moment-timezone';
// import { data } from '../../Mock/Associates/index';
import Api from 'Shared/Services/Api/index';
import GetSystemAuthUtil from 'Shared/Utils/ConfigEnvironment/GetSystemAuth/index';

import { IAssociates, IAssociatesFilters, IAssociatesResponse } from '../../Interface/index';

const validFilters = (element: IAssociates, filters: IAssociatesFilters) => {
  let isFilter = true
  if (filters.active && filters.active !== 'Todos' && element?.active?.toString() !== filters.active) {
    isFilter = false
  }
  if (filters.codigo && Number(element.codigo) !== Number(filters.codigo)) {
    isFilter = false
  }
  if (filters.documento && element.documento !== filters.documento) {
    isFilter = false
  }
  if (filters.nome && !element.nome?.includes(filters.nome)) {
    isFilter = false
  }
  return isFilter;
}


export const getAssociatesService = async (params: IAssociatesFilters) => {
  return new Promise<IAssociatesResponse>(async (resolve, reject) => {
    let _arrayReg: [IAssociates?] = [];
    let regReturn: IAssociatesResponse = {
      status: '200',
      message: '',
    };

    try {
      let _config = {
        "systemauth": GetSystemAuthUtil(process.env.REACT_APP_ENVIRONMENT)
      };
      await Api.get('/associado', { params: _config })
        .then(resp => {
          if (resp.data.data && resp.data.data.length > 0) {
            for (let reg of resp.data.data) {
              const _item: IAssociates = {
                id: reg.guidcontrol.value,
                codigo: reg.codigo.value ? reg.codigo.value.padStart(4, '0') : '0000',
                nome: reg.nome.value,
                documento: reg.documento.value,
                email: reg.email.value,
                codigoPrincipal: reg.codigoPrincipal.value ? reg.codigoPrincipal.value.padStart(4, '0') : '0000',
                active: reg.active.value === 1 ? true : false,
                criadoEm: reg.criadoEm.value ? momenttz(reg.criadoEm.value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm') : '',
                alteradoEm: reg.alteradoEm.value ? momenttz(reg.alteradoEm.value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm') : '',
              }
              if (validFilters(_item, params)) {
                _arrayReg.push(_item)
              }
            }
          }
          regReturn.list = _arrayReg;
          resolve(regReturn);
        })
        .catch(error => {
          console.log(error);
          let msgerror = error.stack ? error.stack : 'Ocorreu um erro!';
          if (error.response && error.response.data) {
            msgerror = error.response.data.msgErr;
          }
          if (error.response && error.response.result) {
            msgerror = error.response.result.msgErr;
          }

          regReturn.status = '400';
          regReturn.message = msgerror;
          regReturn.msgErro = JSON.stringify(error);
          reject(regReturn)
        });
    }
    catch (err) {
      console.log('AssociatesReport.Service.getAll.err');
      console.log(err);

      let _msgError = 'Ocorreu um erro!';
      regReturn.status = '400';
      regReturn.message = _msgError;
      regReturn.msgErro = JSON.stringify(err);
      reject(regReturn)
    }
  });
}